module.exports = __webpack_public_path__ + "static/media/up-arrow-svgrepo-com (9).24f1e57a.svg";